import { useRowCountdown } from "./timer";

export function RowTimer({ createdAt, status }) {
  const { remainingMs, isExpired } = useRowCountdown(createdAt, 15 * 60 * 1000);

  const normalized = String(status || "").toLowerCase();
  const isPending = normalized === "pending" || normalized === "in_process";

  if (!isPending || isExpired) {
    return (
      <></>
    );
  }

  const minutes = Math.floor(remainingMs / 60000);
  const seconds = Math.floor((remainingMs % 60000) / 1000); 

  const label = `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;

  return (
    <span className="text-xs font-semibold text-amber-600">
      {label}
    </span>
  );
}
